import { iconAddToCart, iconWishList, viewVariants } from "../icons";
import { templateVariants } from "./templateVariants";

export function formatToCOP(value) {
  if (typeof value !== "number") {
    throw new Error("El valor proporcionado no es un número." + value);
  }

  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

export const templateProduct = (product) => {
  const productAgeInDays =
    (new Date() - new Date(product.published_at)) / (1000 * 60 * 60 * 24);

  const isAvailable = product.available
    ? product.available
    : Array.isArray(product.variants) &&
      product.variants.some((variant) => variant.available);

  const productImage =
    product.images?.[0]?.src || product.image?.src || product.image;

  const price = product.price
    ? Number(product.price)
    : Number(product.variants[0]?.price) || 0;

  const comparePrice = Number(product.variants[0]?.compare_at_price) || null;

  const discountPercent = comparePrice
    ? Math.round(((comparePrice - price) / comparePrice) * 100)
    : 0;

  let variantsLength = product.variants.length;

  return `
    <article class="product-article ${
      !isAvailable ? "product-article--unavailable" : ""
    }">
     ${
       variantsLength > 1
         ? templateVariants(product.options, product.variants, product.handle)
         : ""
     }
      <div class="product-article__top">
      <div class="${
        isAvailable
          ? "product-article__top--available"
          : "product-article__a--disabled"
      }">
        <a href="/products/${product.handle}"
        class="product-article__top--action"
        >
          </a>
          <figure class="product-article__figure">
            <img src="${productImage}" alt="${product.title}">
          </figure>
          ${
            !isAvailable
              ? ' <span class="product-article__a--sold-out">Agotado</span>'
              : ""
          }
      </div>
        <div class="product-article__handlers">
          <div class="product-article__handlers--tags">
            ${
              discountPercent > 0
                ? `<span class="product-article__handlers--span product-article__handlers--percent">-${discountPercent}%</span>`
                : ""
            }
            ${
              productAgeInDays <= 15
                ? '<span class="product-article__handlers--span product-article__handlers--new">Nuevo</span>'
                : ""
            }
          </div>
          <button style="opacity:0;" class="product-article__handlers--wish-list add-wish-list">
            <i>${iconWishList}</i>
          </button>
          ${
            variantsLength > 1
              ? `<button class="product-article__handlers--add-to-cart product-article__handlers--open-variants">
            <i>${viewVariants}</i>
          </button>`
              : `<button class="product-article__handlers--add-to-cart add-to-cart" 
          data-product-id="${product.variants[0]?.id}" ${
                  !isAvailable ? "disabled" : ""
                }>
          <i>${iconAddToCart}</i>
          <div class="product-article__action--loader">
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
            <div class="circle"></div>
          </div>
        </button>`
          }
        </div>
      </div>
      <a href="/products/${product.handle}">
        <div class="product-article__info">
          <div class="product-article__price">
            <span class="product-article__price--full">${formatToCOP(
              price
            )}</span>
            ${
              comparePrice
                ? `<span class="product-article__price--compare">${formatToCOP(
                    comparePrice
                  )}</span>`
                : ""
            }
            ${
              variantsLength > 1
                ? `<span class="product-article__price--variants"></span>`
                : ""
            }
          </div>
          <h2 class="product-article__h2">${product.title}</h2>
        </div>
      </a>
    </article>`;
};
